<template>
  <v-container>
    <h1 class="text-center">Custom Commands</h1>
    <div class="custom-container2">
      <p class="text-center"><b>Hier stehen die Verfügbaren Varriablen für die
        Custom Commands!</b></p>
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[display-name]</span> wird verwendet
            um den Command ausführenden zu makieren.</p>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[toUser]</span> wird verwendet
            um den Namen des erwähnten Viewers im Command zu benutzen.</p>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[count]</span> wird verwendet
          um die Häufigkeit, eines Ereignisses zu zählen. Wird dem Command ein Name mitgegeben
          (z.B. <i>!lost PlayerName</i>), führt [count] einen eigenen Zähler je Name (Symbol
          <v-icon x-small>mdi-counter</v-icon> in der Command-Liste).</p>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[sub_count]</span> wird verwendet
            um die aktuelle Anzahl an Subs auszugeben.</p>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[sub_points]</span> wird verwendet
            um die aktuelle Anzahl an Abo Punkten auszugeben.</p>
        </v-col>
        <v-col cols="12" sm="6" md="2">
          <p class="text-center"><span style="color: #00ffcd;">[follower]</span> wird verwendet
            um die aktuelle Anzahl an Followern auszugeben.</p>
        </v-col>
      </v-row>
    </div>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown"
        color="success"
        class="ml-2"
        @click="createDialog = true"
        :disabled="$store.state.user_perm < 4"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="commands"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:[`item.userCooldown`]="{ item }">
        {{ getUserCooldownText(item.cooldowntyp, item.userCooldown) }}
      </template>
      <template v-slot:[`item.cooldown`]="{ item }">
        {{ getGlobalCooldownText(item.cooldowntyp, item.cooldown) }}
      </template>
      <template v-slot:top>
        <v-dialog
          persistent
          v-model="dialog"
          max-width="80vw"
        >
          <v-card>
            <v-form ref="form" v-model="formValid">
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="editedItem.cmd"
                      label="Command"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="editedItem.perm"
                      :items="Rang"
                      label="Permission"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="editedItem.cooldowntyp"
                      label="Global Cooldown"
                      :disabled="editedItem.cooldowntyp === 2"
                      :true-value="1"
                      :false-value="3"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="editedItem.cooldown"
                      label="Globale Cooldown in s"
                      type="Number"
                      :rules="editedItem.cooldowntyp === 1 ? rulesPositiveNumber : []"
                      min="1"
                      :disabled="editedItem.cooldowntyp === 2"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                      v-model="editedItem.cooldowntyp"
                      label="User Cooldown"
                      :disabled="editedItem.cooldowntyp === 1"
                      :true-value="2"
                      :false-value="3"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                      v-model="editedItem.userCooldown"
                      label="User Cooldown in s"
                      type="Number"
                      :rules="editedItem.cooldowntyp === 2 ? rulesPositiveNumber : []"
                      min="1"
                      :disabled="editedItem.cooldowntyp === 1"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.cmd_content"
                      label="cmd_content"
                      rows="1"
                      auto-grow
                      counter="2000"
                      maxLength="2000"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="editedItem.description"
                      label="Description"
                      rows="1"
                      auto-grow
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" class="chipGroup">
                    <v-label>Alias</v-label>
                    <v-chip-group multiple>
                      <v-chip
                        v-for="tag in editedItem.alias"
                        :key="tag"
                        close
                        close-icon="mdi-delete"
                        @click="editAlias(tag)"
                        @click:close="removeAlias(tag)"
                      >
                        <v-text-field
                          v-if="editedAlias === tag"
                          v-model="editedAliasValue"
                          @keydown="checkEditAliasKey"
                          @change="saveEditAlias"
                        ></v-text-field>
                        <span v-else>{{ tag }}</span>
                      </v-chip>
                      <v-btn fab small dark @click="newAlias">
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                    </v-chip-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="saving">Save</v-btn>
            </v-card-actions>
            <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
              Überprüfe die roten Felder!
              <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
              </template>
            </v-snackbar>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sicher diesen Command löschen?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)" v-bind="attrs" v-on="on"
              :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editieren!</span>
        </v-tooltip>
        <v-tooltip top color="info">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="openCounters(item)" v-bind="attrs" v-on="on"
            >
              mdi-counter
            </v-icon>
          </template>
          <span>Zähler pro Name anzeigen!</span>
        </v-tooltip>
        <v-tooltip top color="error">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              @click="deleteItem(item)" v-bind="attrs" v-on="on"
              :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
            >
              mdi-delete
            </v-icon>
          </template>
          <span>Löschen!</span>
        </v-tooltip>
        <v-switch
          v-model="item.active"
          color="success"
          :true-value="1"
          :false-value="0"
          hide-details
          @change="saveSwitchState(item)"
          :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
        ></v-switch>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="dialog">Reset</v-btn>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in filteredCommands"
        :key="item.id"
        class="mb-3"
        outlined
      >
        <v-card-title class="d-flex justify-space-between align-center py-2">
          <span class="cmd-label">{{ item.cmd }}</span>
          <v-switch
            v-model="item.active"
            color="success"
            :true-value="1"
            :false-value="0"
            hide-details
            @change="saveSwitchState(item)"
            :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
            class="mt-0 pt-0 flex-grow-0"
          ></v-switch>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <v-chip x-small class="mr-1">{{ item.perm }}</v-chip>
          <v-chip x-small color="info" v-if="item.cooldowntyp === 1">Global CD: {{ item.cooldown }}s</v-chip>
          <v-chip x-small color="warning" v-else-if="item.cooldowntyp === 2">User CD: {{ item.userCooldown }}s</v-chip>
        </v-card-subtitle>
        <v-card-text class="pt-2">
          <div v-if="item.cmd_content" class="body-2 text-truncate cmd-content-preview">{{ item.cmd_content }}</div>
          <div v-if="item.description" class="caption grey--text mt-1">{{ item.description }}</div>
          <div v-if="item.alias && item.alias.length" class="caption mt-1">
            Alias: {{ item.alias.join(', ') }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="editItem(item)"
            :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
          >
            <v-icon color="success">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="openCounters(item)"
          >
            <v-icon color="info">mdi-counter</v-icon>
          </v-btn>
          <v-btn
            icon
            @click="deleteItem(item)"
            :disabled="$store.state.user_perm < 4 || $store.state.user_perm < item.user_perm"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-alert v-if="filteredCommands.length === 0" type="info" class="mt-2">
        Keine Commands gefunden.
      </v-alert>

      <!-- Mobile Edit Dialog (fullscreen) -->
      <v-dialog persistent v-model="dialog" fullscreen>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Command bearbeiten</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn text @click="save" :loading="saving">Speichern</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form ref="form" v-model="formValid">
            <v-container class="pa-4">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="editedItem.cmd" label="Command" outlined></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select v-model="editedItem.perm" :items="Rang" label="Permission" outlined></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="editedItem.cooldowntyp"
                    label="Global Cooldown"
                    :disabled="editedItem.cooldowntyp === 2"
                    :true-value="1"
                    :false-value="3"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.cooldown"
                    label="Global Cooldown in s"
                    type="Number"
                    :rules="editedItem.cooldowntyp === 1 ? rulesPositiveNumber : []"
                    min="1"
                    :disabled="editedItem.cooldowntyp === 2"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-checkbox
                    v-model="editedItem.cooldowntyp"
                    label="User Cooldown"
                    :disabled="editedItem.cooldowntyp === 1"
                    :true-value="2"
                    :false-value="3"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="editedItem.userCooldown"
                    label="User Cooldown in s"
                    type="Number"
                    :rules="editedItem.cooldowntyp === 2 ? rulesPositiveNumber : []"
                    min="1"
                    :disabled="editedItem.cooldowntyp === 1"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.cmd_content"
                    label="Command Inhalt"
                    rows="2"
                    auto-grow
                    counter="2000"
                    maxLength="2000"
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.description"
                    label="Description"
                    rows="2"
                    auto-grow
                    outlined
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="chipGroup">
                  <v-label>Alias</v-label>
                  <v-chip-group multiple>
                    <v-chip
                      v-for="tag in editedItem.alias"
                      :key="tag"
                      close
                      close-icon="mdi-delete"
                      @click="editAlias(tag)"
                      @click:close="removeAlias(tag)"
                    >
                      <v-text-field
                        v-if="editedAlias === tag"
                        v-model="editedAliasValue"
                        @keydown="checkEditAliasKey"
                        @change="saveEditAlias"
                      ></v-text-field>
                      <span v-else>{{ tag }}</span>
                    </v-chip>
                    <v-btn fab small dark @click="newAlias">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
            <v-snackbar v-model="ErrorFlag" timeout="3000" color="red">
              Überprüfe die roten Felder!
              <template v-slot:actions>
                <v-btn color="pink" variant="text" @click="ErrorFlag = false">Close</v-btn>
              </template>
            </v-snackbar>
          </v-form>
        </v-card>
      </v-dialog>

      <!-- Mobile Delete Dialog -->
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Sicher diesen Command löschen?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Nein!</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Ja!</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Desktop: Create Form -->
    <v-form
      v-if="!$vuetify.breakpoint.smAndDown"
      ref="createForm"
      v-model="valid"
      lazy-validation
    >
      <v-text-field
        v-model="command"
        :counter="32"
        :rules="[v => !!v || 'Item is required']"
        label="Command"
        required
      ></v-text-field>
      <v-select
        v-model="perm"
        :items="Rang"
        :rules="[v => !!v || 'Item is required']"
        label="Permission"
        required
      ></v-select>
      <v-text-field
        v-model="command_content"
        :rules="[v => !!v || 'Item is required']"
        label="Command Inhalt"
        required
      ></v-text-field>
      <v-text-field
        v-model="description"
        label="Description"
      ></v-text-field>
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        Command erstellen
      </v-btn>
    </v-form>

    <!-- Mobile: Create Dialog -->
    <v-dialog
      v-if="$vuetify.breakpoint.smAndDown"
      v-model="createDialog"
      fullscreen
    >
      <v-card>
        <v-toolbar dark color="success">
          <v-btn icon dark @click="createDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Command erstellen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="validate">Erstellen</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-form ref="createForm" v-model="valid" lazy-validation class="pa-4">
          <v-text-field
            v-model="command"
            :counter="32"
            :rules="[v => !!v || 'Item is required']"
            label="Command"
            required
            outlined
          ></v-text-field>
          <v-select
            v-model="perm"
            :items="Rang"
            :rules="[v => !!v || 'Item is required']"
            label="Permission"
            required
            outlined
          ></v-select>
          <v-text-field
            v-model="command_content"
            :rules="[v => !!v || 'Item is required']"
            label="Command Inhalt"
            required
            outlined
          ></v-text-field>
          <v-text-field
            v-model="description"
            label="Description"
            outlined
          ></v-text-field>
        </v-form>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="commandCreated" timeout="3000" color="green">
      Command erfolgreich erstellt!
      <template v-slot:actions>
        <v-btn color="pink" variant="text" @click="commandCreated = false">Close</v-btn>
      </template>
    </v-snackbar>

    <!-- Zähler pro Name Dialog -->
    <v-dialog v-model="countersDialog" max-width="700px">
      <v-card>
        <v-card-title>
          Zähler für <span class="cmd-label ml-2">{{ countersItem.cmd }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="!loadingCounters && counters.length === 0" type="info" dense>
            Noch keine Zähler für diesen Command vorhanden. Ein Zähler wird erstellt, sobald
            der Command das erste Mal mit einem Namen aufgerufen wird (z.B. <i>!{{ countersItem.cmd }} PlayerName</i>).
          </v-alert>
          <v-list v-else dense>
            <v-list-item v-for="counter in counters" :key="counter.id">
              <v-list-item-content>
                <v-list-item-title>{{ counter.target_name }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action class="counter-value">
                <v-text-field
                  v-model.number="counter.count"
                  type="number"
                  dense
                  hide-details
                  style="width: 90px;"
                ></v-text-field>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn icon small @click="saveCounter(counter)" :loading="savingCounterId === counter.id">
                  <v-icon color="success" small>mdi-content-save</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn icon small @click="deleteCounter(counter)">
                  <v-icon color="error" small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="countersDialog = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>

import BackendService from '@/services/BackendService';

export default {
  name: 'CustomCommands',
  data: () => ({
    description: '',
    search: '',
    dialog: false,
    createDialog: false,
    commands: [],
    saving: false,
    Rang: ['Everyone', 'Sub', 'Vip', 'Mod', 'Editor', 'Admin', 'Streamer'],
    headers: [
      { text: 'Command', value: 'cmd', align: 'center' },
      { text: 'Alias', value: 'alias', align: 'center' },
      { text: 'Permission', value: 'perm', align: 'center' },
      { text: 'User Cooldown in s', value: 'userCooldown', align: 'center' },
      { text: 'Global Cooldown in s', value: 'cooldown', align: 'center' },
      { text: 'Command Inhalt', value: 'cmd_content', align: 'center' },
      { text: 'Description', value: 'description' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
    },
    defaultItem: {
    },
    editedAlias: null,
    editedAliasValue: '',
    formValid: false,
    rulesPositiveNumber: [
      (v) => !!v || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) > 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    rulesWith0: [
      (v) => (v !== null && (v) !== undefined) || 'Feld darf nicht leer sein',
      (v) => !Number.isNaN(v) || 'Nur Zahlen sind erlaubt',
      (v) => parseFloat(v) >= 0 || 'Zahl muss positiv sein',
      (v) => parseFloat(v) <= 10000000 || 'Zahl darf höchstens 10.000.000 sein',
    ],
    ErrorFlag: false,
    countersDialog: false,
    countersItem: {},
    counters: [],
    loadingCounters: false,
    savingCounterId: null,
  }),
  computed: {
    filteredCommands() {
      if (!this.search) return this.commands;
      const s = this.search.toLowerCase();
      return this.commands.filter((c) => (c.cmd && c.cmd.toLowerCase().includes(s))
        || (c.cmd_content && c.cmd_content.toLowerCase().includes(s))
        || (c.description && c.description.toLowerCase().includes(s)));
    },
  },
  mounted() {
    BackendService.loadCustomCommand(1).then((data) => {
      this.commands = data.data;
    });
  },
  methods: {
    getUserCooldownText(cooldownType, userCooldown) {
      switch (cooldownType) {
        case 2:
          return userCooldown;
        default:
          return '-';
      }
    },
    getGlobalCooldownText(cooldownType, globalCooldown) {
      switch (cooldownType) {
        case 1:
          return globalCooldown;
        default:
          return '-';
      }
    },
    newAlias() {
      this.editedItem.alias.push('');
      this.editAlias('');
    },
    editItem(item) {
      this.editedIndex = this.commands.indexOf(item);
      this.editedItem = { ...item };
      this.editedItem.alias = item.alias.slice();
      this.editedItem.active = item.active;
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.commands.indexOf(item);
      this.editedItem = { ...item };
      this.editedItem.alias = item.alias.slice();
      this.dialogDelete = true;
    },
    removeAlias(alias) {
      this.editedItem.alias = this.editedItem.alias.filter((item) => item !== alias);
    },
    editAlias(alias) {
      this.editedAlias = alias;
      this.editedAliasValue = alias;
    },
    saveEditAlias() {
      const idx = this.editedItem.alias.indexOf(this.editedAlias);
      this.editedItem.alias[idx] = this.editedAliasValue;
      this.editedAlias = null;
    },
    checkEditAliasKey(e) {
      if (e.keyCode === 13) {
        this.saveEditAlias();
      } else if (e.keyCode === 27) {
        this.editedAlias = null;
      }
    },
    deleteItemConfirm() {
      BackendService.deleteCustomCommand({
        id: this.editedItem.id,
        variant: 1,
      }).then((data) => {
        this.commands = data.data;
        this.closeDelete();
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.editedAlias = null;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.editedAlias = null;
      });
    },
    save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        BackendService.saveCustomCommand({
          id: this.editedItem.id,
          cmd: this.editedItem.cmd,
          perm: this.editedItem.perm,
          alias: this.editedItem.alias,
          cmd_content: this.editedItem.cmd_content,
          description: this.editedItem.description,
          cooldown: this.editedItem.cooldown,
          userCooldown: this.editedItem.userCooldown,
          cooldowntyp: this.editedItem.cooldowntyp,
          variant: 1,
        }).then((data) => {
          this.commands = data.data;
          this.saving = false;
          this.close();
        });
      } else this.ErrorFlag = true;
    },
    validate() {
      if (this.$refs.createForm.validate()) {
        BackendService.insertCustomCommand({
          cmd: this.command,
          perm: this.perm,
          cmd_content: this.command_content,
          description: this.description,
          variant: 1,
        }).then((data) => {
          this.commandCreated = true;
          this.$refs.createForm.reset();
          this.commands = data.data;
          this.createDialog = false;
        });
      }
    },
    saveSwitchState(item) {
      if (item.active) {
        this.saveSwitchStateDB(item.id, 1);
      } else {
        this.saveSwitchStateDB(item.id, 0);
      }
    },
    saveSwitchStateDB(id, state) {
      BackendService.saveSwitchStateCCommands({
        active: state,
        id1: id,
        variant: 1,
      }).then((data) => {
        this.commands = data.data;
      }).catch(() => {
        alert('nö!');
      });
    },
    openCounters(item) {
      this.countersItem = item;
      this.countersDialog = true;
      this.fetchCounters();
    },
    fetchCounters() {
      this.loadingCounters = true;
      BackendService.loadCommandCounters({
        id: this.countersItem.id,
        variant: 1,
      }).then((data) => {
        this.counters = data.data;
        this.loadingCounters = false;
      }).catch(() => {
        this.loadingCounters = false;
      });
    },
    saveCounter(counter) {
      this.savingCounterId = counter.id;
      BackendService.saveCommandCounter({
        id: counter.id,
        command_id: this.countersItem.id,
        count: counter.count,
        variant: 1,
      }).then((data) => {
        this.counters = data.data;
        this.savingCounterId = null;
      }).catch(() => {
        this.savingCounterId = null;
      });
    },
    deleteCounter(counter) {
      BackendService.deleteCommandCounter({
        id: counter.id,
        command_id: this.countersItem.id,
        variant: 1,
      }).then((data) => {
        this.counters = data.data;
      });
    },
  },
};
</script>
<style>
.chipGroup label {
  font-size: 12px;
}

.custom-container2 {
  border: 1px solid #565656;
  border-radius: 10px;
  padding: 20px;
  padding-bottom: 5px;
  margin: 20px auto;
}

.custom-container3 {
  border: 1px solid #565656;
  border-radius: 10px;
  padding: 20px;
  padding-bottom: 5px;
  max-width: 900px;
  margin: 20px auto;
}

.custom-container4 {
  border: 1px solid #565656;
  border-radius: 10px;
  padding: 20px;
  padding-bottom: 5px;
  width: 100%;
  margin: 20px auto;
}

.cmd-label {
  color: #00ffcd;
  font-size: 1.1rem;
  font-weight: bold;
  word-break: break-all;
}

.cmd-content-preview {
  color: rgba(255, 255, 255, 0.7);
}
</style>
